import React from 'react';
import { AdminLayoutView, StartChannelGroup, updateStartChannels } from 'pages/administration.page';

export class StartChannelPageComponent extends React.Component {
  state = {
    isModalOpen: false,
  };

  onModalClose = (groupName) => {
    if (groupName) {
      this.props.updateState(updateStartChannels(this.props.startChannels, groupName, 0));
    }

    this.setState({ isModalOpen: false });
  };

  saveState = () => {
    this.props.updateStartChannels(this.props.startChannels);
  };

  openModal = () => this.setState({ isModalOpen: true });

  render() {
    return (
      <AdminLayoutView
        {...{
          isModalOpen: this.state.isModalOpen,
          onModalClose: this.onModalClose,
          openModal: this.openModal,
          saveState: this.saveState,
          showBlockUi: this.props.isLoading,
        }}
      >
        <div className="start-channel-page">
          <div className="row admin-start-title">
            <div className="col-xl-6 col-6">
              <span className="start-channel-title">Group</span>
            </div>
            <div className="col-xl-6 col-6">
              <span>Channel</span>
            </div>
          </div>
          {this.props.startChannels &&
            this.props.startChannels.map((group, index) => (
              <StartChannelGroup
                key={index}
                group={group}
                startChannels={this.props.startChannels}
                updateState={this.props.updateState}
              />
            ))}
        </div>
      </AdminLayoutView>
    );
  }
}
